export class ProductsProperties{
  propiedades:any[];

  constructor(propiedades){
    this.propiedades = [];
    this.propiedades.push({'propiedad':propiedades.especie});
    this.propiedades.push({'propiedad':propiedades.estado});
    this.propiedades.push({'propiedad':propiedades.empaque1});
    this.propiedades.push({'propiedad':propiedades.empaque2});
    this.propiedades.push({'propiedad':propiedades.empaque3});
    this.propiedades.push({'propiedad':propiedades.compensado});
    this.propiedades.push({'propiedad':propiedades.hidratacion});
    this.propiedades.push({'propiedad':propiedades.glaciado});
    this.propiedades.push({'propiedad':propiedades.presentacion1});
    this.propiedades.push({'propiedad':propiedades.presentacion2});
    this.propiedades.push({'propiedad':propiedades.peso});
    this.propiedades.push({'propiedad':propiedades.calibre});

  }


  public getJson(){
    let coma =',';
    let esp = '';
    for(let i=0;i < this.propiedades.length;i++){
      if((i+1) === this.propiedades.length){
        coma = '';
      }
      esp += `{"type":"products_properties","property_id":"${this.propiedades[i].propiedad}"}${coma}`;
    }

    return `{"data":[${esp}]}`;

  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/ProductProperties.ts